import { type MCPServerInfo } from '../../types';

const SplunkServer: MCPServerInfo = {
  serverId: 'SPLUNK',
  name: 'Splunk',
  slug: 'splunk',
  description:
    'Connect to Splunk Cloud MCP using a dynamic endpoint and bearer token.',
  source: {
    sourceType: 'DYNAMIC_REMOTE_URL',
    mcpServerUrl:
      'https://{splunkDeployment}.splunkcloud.com:8089/services/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['splunkDeployment', 'splunkBearerToken'],
    properties: {
      splunkDeployment: {
        type: 'string',
        description:
          'Splunk Cloud deployment prefix ({splunkDeploymentPrefix}}.splunkcloud.com).',
        sensitive: false,
        isUrlParameter: true
      },
      splunkBearerToken: {
        type: 'string',
        description: 'Splunk bearer token (without the Bearer prefix).',
        sensitive: true
      }
    }
  }
};

export default SplunkServer;
